import Flickity from "flickity";

document.addEventListener('alpine:init', () => {
    Alpine.data('contentCarousel', () => ({
        slider: null,
        sliderContainer: null,
        currentIndex: 0,
        isAnimating: false,
        init() {
            this.sliderContainer = this.$refs.slider;
            const slides = this.sliderContainer.querySelectorAll('.Content__Carousel-slide');

            this.slider = new Flickity(this.sliderContainer, {
                cellAlign: 'center',
                contain: true,
                freescroll: true,
                wrapAround: true,
                prevNextButtons: false,
                pageDots: false,
                draggable: true,
                selectedAttraction: 0.2,
                friction: 0.8,
                on: {
                    settle: () => {
                        this.currentIndex = this.slider.selectedIndex;
                    },
                    ready: () => {
                        window.dispatchEvent(new Event('resize'));
                        this.sliderResize();
                    }
                }
            });

            this.currentIndex = this.slider.selectedIndex;

            pegasus.onResizeFinished(() => {
                this.sliderResize();
            }, false);
        },

        sliderResize() {
            const flickitySliders = document.querySelectorAll('.Content__Carousel-slider .flickity-slider');
            
            this.sliderFullWidth = 0;
            
            flickitySliders.forEach(slider => {
                const slides = slider.querySelectorAll('.Content__Carousel-slide');
                let height = 0;

                slides.forEach(slide => {
                    slide.style.height = '';
                    this.sliderFullWidth += slide.offsetWidth;
                    if(slide.offsetHeight > height){
                        height = slide.offsetHeight;
                    }
                });

                slides.forEach(slide => {
                    slide.style.height = height+'px';
                })

                slider.style.height = '';
                slider.style.height = height+'px';

            });
        },

        previousSlide() {
            if (window.innerWidth >= 768) {
                this.isAnimating = true;
            }
            this.slider.previous();
            setTimeout(() => {
                this.isAnimating = false;
            }, 700);
        },
        nextSlide() {
            if (window.innerWidth >= 768) {
                this.isAnimating = true;
            }
            this.slider.next();
            setTimeout(() => {
                this.isAnimating = false;
            }, 700);
        }
    }))
});
